define.alias("ember-in-viewport/initializers/viewport-config", "calendar/initializers/viewport-config");